module.exports = __webpack_public_path__ + "img/company_part3img2.43963c1e.jpg";